<template>
    <el-menu class="left-sidebar-menu" @select="handleSelect" :default-active="$route.path" :default-openeds="['/doc/sdk']">
        <el-menu-item index="/doc/api">
            <i class="el-icon-connection"></i>
            <span slot="title">{{$t('docking.docApi')}}</span>
        </el-menu-item>
        <el-submenu index="/doc/sdk">
            <template slot="title">
                <i class="el-icon-finished"></i>
                {{ $t("docking.docSdk")}}
            </template>
            <el-menu-item index="/doc/sdkWord">
                <i class="el-icon-document"></i>
                <span slot="title">{{ $t("docking.docSdkWord")}}</span>
            </el-menu-item>
            <el-menu-item index="/doc/sdkTest">
                <i class="el-icon-odometer"></i>
                <span slot="title">{{ $t("docking.docSdkTest")}}</span>
            </el-menu-item>
        </el-submenu>
  </el-menu>
</template>
<script>
    export default {
        methods: {
           handleSelect(key, keyPath) {
                return this.$router.push(key)
           },
        }
    }
</script>

<style>
.el-menu-item .bar-chart.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../assets/img/bar-chart-grey.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.el-menu-item.is-active .bar-chart.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../assets/img/bar-chart-blue.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.el-menu-item .dollar.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../assets/img/dollar-grey.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.el-menu-item.is-active .dollar.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../assets/img/dollar-blue.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
}

</style>
